(function (e) {
        e.fn.tabs = function () {
            e(this).find(".tabs-nav");
            var i = e(this).find(".tabs-nav li"),
                o = (e(this).find(".tabs-content"), e(this).find(".tabs-content li"));
            e(i[0]).addClass("active"),
                e(o[0]).addClass("active"),
                e.each(i, function (i) {
                    e(this).addClass("tab-nav-" + i);
                }),
                e.each(o, function (i) {
                    e(this).addClass("tab-content-" + i);
                }),
                i.on("click", function () {
                    var t = e(this).attr("class"),
                        s = t.lastIndexOf("-");
                    t = parseInt(t.substr(s + 1));
                    var a = e(o[t]);
                    i.removeClass("active"), o.removeClass("active"), a.addClass("active"), e(this).addClass("active");
                });
        };
    })(jQuery),
    $("#tabs").tabs();
$(document).ready(function () {
      $(".nav-container .slider-nav .wrapper").click(function () {
        if($(this).hasClass("video")){          
          $(".main-container .vid-con").html($(this).find('img').attr("data-video")).show();
          $(".main-container img").hide();
          $(".slider-nav .wrapper").removeClass("active");
          $(this).addClass("active");
         $(".play-bt").hide();
         $(".pause-bt").show();
         var ban_video = document.getElementById("ban_video");
          ban_video.play();  
          $("#ban_video").prop('muted', true);
          $(".mute-bt").addClass("stop");
          videoReady();
        }else{
          $(".main-container .vid-con").hide();
          $(".main-container img").show();
          $(".main-container img").attr("src",$(this).find('img').attr("data-large"));
          $(".main-container .zoom").css("background-image", "url("+$(this).find('img').attr('data-large')+")");
          $(".main-container img").attr("src",$(this).find('img').attr("data-large")).fadeIn(); 
          $(".slider-nav .wrapper").removeClass("active");
          $(this).addClass("active");
           var ban_video = document.getElementById("ban_video");
           $("#ban_video").prop('muted', true);
           $(".mute-bt").addClass("stop");
        }
      });

      playSwipe();
    });


  

function loadvideo(){ 
    
  if($(".nav-container-mobile .video").length > 0 && $(".nav-container-mobile video").length == 0){ 
        $(".nav-container-mobile .wrapper.video").each(function( index ) {
          var data=$(this).find('img').attr("data-video");
          $(this).html(data).show();
           videoReady();
          playPauseVideo();
        });
      }
}


function videoReady(){
  $(".mute-bt").click(function(){
    if($(this).hasClass("stop")){
      var ban_video = document.getElementById("ban_video");
      $("#ban_video").prop('muted', false);
      $(this).removeClass("stop");
    }
    else{
      var ban_video = document.getElementById("ban_video");
      $("#ban_video").prop('muted', true);
      $(this).addClass("stop");
    }
  });

  $(".play-bt").click(function(){
    $(".play-bt").hide();
    $(".pause-bt").show();    
    var ban_video = document.getElementById("ban_video");
    ban_video.play();                                         
  });
  $(".pause-bt").click(function(){
    $(".play-bt").show();
    $(".pause-bt").hide();
    var ban_video = document.getElementById("ban_video");
    ban_video.pause();                                         
  });
} 

function playPauseVideo() {
    let videos = document.querySelectorAll(".nav-container-mobile video");
    videos.forEach((video) => {
        // We can only control playback without insteraction if video is mute
        video.muted = true;
        $(".mute-bt").addClass("stop");
        // Play is a promise so we need to check we have it
        let playPromise = video.play();
        if (playPromise !== undefined) {
            playPromise.then((_) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                          if(entry.isIntersecting == true){
                        
                            if (
                                entry.intersectionRatio !== 1 &&
                                !video.paused
                            ) {
                                video.pause();
                              
                            } else if (video.paused) {
                                video.play();
                              $(".play-bt").hide();
                              $(".pause-bt").show();  
                            }
                          }else{
                             video.pause();
                          }
                        });
                    },
                    { threshold: 0.2 }
                );
                observer.observe(video);
            });
        }
    });
}

function playSwipe() {
    let views = document.querySelectorAll(".nav-container-mobile .wrapper");
    views.forEach((view) => {
                let observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                          
                          if(entry.isIntersecting == true){
                           if($(".nav-container-mobile .video").length > 0 && $(".nav-container-mobile video").length == 0){ 
                             loadvideo();
                          }
                              $(".nav-container-mobile .slider-nav .wrapper").removeClass("active");
                            $(".nav-container-mobile #pagination label").removeClass("active");
                            $(entry.target).addClass("active");
                            $($(entry.target).attr("data-for")).addClass("active")
                          }
                        });
                    },
                    { threshold: 0.2 }
                );
                observer.observe(view);
    });
}
console.log(window.location.hostname);